import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"
import Breadcrumb from "src/components/layouts/Common/Breadcrumb"
import Sidebar from "src/components/layouts/sidebar/Sidebar"
import HolidaysList from "src/components/panel/holidays/HolidaysList"

const HolidaysListView=()=>{
    const {t}=useTranslation()
    return<>
    <Helmet>
        <title>{t('holidays_list_tab')}</title>
    </Helmet>
    <Sidebar>
        <Breadcrumb title={t("holidays_list_title")} subtitle={t('holidays_list_subtitle')}/>
        <HolidaysList/>
    </Sidebar>
    
    
    
    </>
}
export default HolidaysListView